import React, { useEffect } from 'react'
import Select from 'react-select'
const MultiSelectTags = ({ options, value, defaultSelect, placeholder, onChange }) => {
    return (
      <Select
        defaultValue={defaultSelect}
        isMulti
        name="tags"
        placeholder={placeholder}
        options={options}
        value={value} 
        className="basic-multi-select"
        classNamePrefix="select"
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            padding: state.hasValue ? '6px 12px' : '13px',
          }),
        }}
        hideSelectedOptions={false}
        isSearchable={false}
        onChange={onChange} 
        formatOptionLabel={tag => (
          <div className="user-option d-flex align-items-center gap-2">
            <span style={{ marginTop: "1px", backgroundColor: `${tag.color}` }} className="wd-7 ht-7 rounded-circle"></span>
            <span>{tag.label}</span>
          </div>
        )}
      />
    )
  }

export default MultiSelectTags